import { css } from "@linaria/core"

import { ellipsis } from "@/styles/mixins.ts"

export const AgentIterationStyles = {
  header: css`
    padding: 0 16px;
  `,

  secondLevelMarkdown: css`
    ${ellipsis};

    em {
      font-size: 11px;
      font-family: monospace;
      font-style: normal;
    }
  `,

  secondLevelMarkdownFull: css`
    em {
      font-size: 11px;
      font-family: monospace;
      font-style: normal;
    }
  `,

  secondLevelText: css`
    max-width: 100%;

    color: var(--secondary-text-color);
  `,

  secondLevelText_Loading: css`
    @keyframes slide-text {
      0% {
        background-position: 100% 0;
      }

      100% {
        background-position: -100% 0;
      }
    }

    animation: slide-text 2s ease-in-out infinite;
    background-image: linear-gradient(120deg, var(--secondary-text-color) 40%, transparent 50%, var(--secondary-text-color) 60%);
    background-size: 200% 100%;
    background-clip: text;
    color: transparent;
  `
}
